import { c as _c } from "react/compiler-runtime";
import type { HandleProps } from '@xyflow/react';
import { Handle } from '@xyflow/react';
type CustomHandleProps = Pick<HandleProps, 'type' | 'position' | 'id'>;
const CustomHandle = t0 => {
  const $ = _c(4);
  const {
    type,
    position,
    id
  } = t0;
  const t1 = `${id}-${position}`;
  let t2;
  if ($[0] !== position || $[1] !== t1 || $[2] !== type) {
    t2 = <Handle type={type} position={position} id={t1} className="!w-0 !h-0 !min-w-0 !min-h-0 !p-0 !m-0 !border-0 invisible absolute" />;
    $[0] = position;
    $[1] = t1;
    $[2] = type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default CustomHandle;